import React from 'react';
import Container from '../shared/Container';
import { Button } from 'flowbite-react';
import { useNavigate } from 'react-router-dom';

interface AttendanceConfirmedProps {
	driveID?: string;
	DriveIdGlobal?: string;
}

const AttendanceConfirmed: React.FC<AttendanceConfirmedProps> = ({ driveID, DriveIdGlobal }) => {
	const navigate = useNavigate();
	return (
		<Container>
			<div className="flex flex-col max-w-[580px] mx-auto rounded-[8px] justify-center">
				<div className="flex flex-col">
					<div className="max-w-[60px] max-h-[60px] mx-auto mt-[64px]">
						<img src="/assets/assessmentcompleted/circle.svg" className="w-full h-full" />
					</div>
					<div className="flex flex-col justify-center items-center gap-[16px] pt-[32px] max-w-[475px] w-full">
						<p className="text-center font-inter text-[24px] font-[500] leading-[30px] text-[#7777E7]">
							Attendance Confirmed
						</p>
						<p className="text-center font-inter text-[14px] font-medium leading-[20px] inline-block text-[#555770] pb-[20px] max-w-[475px] w-full">
							Kindly collect your id card from the registration desk.
						</p>
					</div>
					<div className="flex flex-col justify-center items-center pb-[30px]">
						<Button
							type="button"
							color="purplePlaced"
							onClick={() => {
								console.log('driveID:', driveID)
								navigate('/offline-drive-day-opportunities' + `?driveId=${driveID}`);
							}}
							className="max-w-[199px] w-full"
						>
							{'View My Opportunities'}
						</Button>
					</div>
				</div>
			</div>
		</Container>
	);
};

export default AttendanceConfirmed;
